import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Carousel, Flex, Toast, PullToRefresh, Modal } from 'antd-mobile';
import Util from 'utils';
import { initConfig } from 'utils/wxUtils';

import cx from 'classnames';
import { Service, FrameWork, ImgWrap, Footer, DownloadBar } from 'pubBiz';
import { PriceText, CardOpenTip } from 'widget';
import Accoumnlate from 'widget/Accoumulate/AccoumulateView';

import config from 'config/Config';
import { toJS } from 'mobx';

import './index.less';

const getFloatWindowPositionClass = (position) => {
  const pos = +position;
  if (pos >= 1 && pos <= 6) {
    return `float-window--pos-${pos}`;
  }
  return 'float-window--pos-default';
};

export default class FloatWindow extends Component {
  static defaultProps = {
    isShow: true,
    isCanClose: 1
  };

  constructor(props) {
    super(props);
    this.state = {
      isHide: false,
      isShow: true
    };
    this.interval = null; // 定时器
    this.topValue = 0; // 上次滚动条到顶部的距离
  }

  componentDidMount() {
    this.setState({
      isShow: this.props.isShow
    });
  }

  componentWillUnmount() {
    // clearInterval(this.interval);
  }

  /**
   * 保存滑动位置
   */
  saveScrollTop = (e) => {
    const scrollTop = this.props.domData.scrollTop;
    // console.log(scrollTop,'floatscrollTop');
    this.setState({ isHide: true }, () => {
      if (!scrollTop && !this.topValue) {
        return;
      }
      if (this.interval == null) {
        this.interval = setInterval(() => this.observeStop(scrollTop), 500);
      } // 未发起时，启动定时器，1秒1执行
    });
  };

  observeStop = (v) => {
    // 判断此刻到顶部的距离是否和1秒前的距离相等
    console.log(v, this.topValue);
    if (v == this.topValue) {
      console.log('scroll bar is stopping!');
      clearInterval(this.interval);
      this.interval = null;
      this.setState({ isHide: false });
    } else {
      this.topValue = v;
      this.setState({ isHide: true });
    }
  };

  /**
   * 悬浮窗
   */
  renderFloatWindow = () => {
    const { isShow } = this.state;
    const { floatWindow, handleAction, position, isCanClose, zIndex } = this.props;
    if (!floatWindow.imgData) return null;
    const positionClass = getFloatWindowPositionClass(position);
    return (
      isShow && (
        <div
          className={cx('float-window', positionClass, {
            'float-window-hide': this.state.isHide
          })}
          style={zIndex != null ? { zIndex } : undefined}
          onClick={() => handleAction && handleAction()}>
          <img className="float-window-img" src={floatWindow.imgData.imgUrl} />
          {+isCanClose !== 0 && (
            <div
              className="close-btn"
              onClick={(e) => {
                e.stopPropagation();
                this.setState({
                  isShow: false
                });
              }}>
              <span className="iconfont icon-reeor" />
            </div>
          )}
        </div>
      )
    );
  };

  render() {
    return (
      <div>
        {/* 悬浮窗 */}
        {/* 666 */}
        {this.renderFloatWindow()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/FloatWindow/index.js